module.exports = __webpack_public_path__ + "static/media/map-hurricane.aaea5d9f.svg";